import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItems, ObjectNames } from '../constants/constants';
import { CustomService } from './custom.service';
import { AppMainService } from 'src/app/app-main.service';

@Component({
  selector: 'app-crm-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CrmCustomComponent implements OnInit, OnDestroy {

  configMenuCustomItems:any[];
  index:number = 0;
  modules = [];
  typesList = [];
  displaySection: boolean = false;

  constructor(private customService: CustomService, private appMainService: AppMainService) { }

  ngOnInit(): void {
    this.displaySection = false;
    this.configMenuCustomItems = [
      {
        label: MenuItems.Add_Field,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddCustomField();
        }
      },
      // {
      //   label: MenuItems.Add_Section,
      //   icon: 'pi pi-plus',
      //   command: () => {
      //     this.showAddCustomSection();
      //   }
      // },
    ]
    this.getModules();
    this.customService.getAllTypes().subscribe(
      types => {
        this.typesList = types;
      },
    )
  }

  getIndex(event){
    this.index = event.index;
    this.displaySection = false;
    if(this.index==1){
      this.displaySection = true;
    }
  }

  showAddCustomField(){
    this.index=0;
    this.customService.setCustom(ObjectNames.BehaviorSubjectVariable);
  }

  showAddCustomSection(){
    this.index=1;
    this.customService.setSection(ObjectNames.BehaviorSubjectVariable);
  }

  getModules() {
    this.appMainService.isShowSpinner('getModules');
    this.customService.getAllModules().subscribe({
        next: modules => {
            this.modules = modules;
            this.appMainService.isHideSpinner('getModules');
        },
        error: ()=>{
            this.appMainService.isHideSpinner('getChannel');
        }
    });
  }

  ngOnDestroy(){
    this.customService.setCustom('');
    this.customService.setSection('');
  }

}
